import type { PropsWithChildren, ReactNode } from 'react';
import styles from './Beliefs.module.css';

export function Beliefs({ children }: PropsWithChildren) {
  return <div className={styles.grid}>{children}</div>;
}

interface BeliefProps {
  label: ReactNode;
  children: ReactNode;
  muted?: boolean;
}

export function Belief({ label, children, muted = false }: BeliefProps) {
  return (
    <div className={`${styles.item} ${muted ? styles.muted : ''}`}>
      <h4 className={styles.label}>{label}</h4>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
